import { ApiService } from "./api.service";
import { PrimeIcons } from "@primevue/core/api";

export default class PermissionService extends ApiService {
  template = "defaultTemplate";
  DOMAIN = -38;
  favicon = "Bullets";
  singular = this.terminology.permission.singular;
  plural = this.terminology.permission.plural;
  vowel = this.terminology.permission.vowel;
  navItems = [
    {
      key: "listing",
      label: this.t("viewAllEntities", { entity: this.plural }),
      icon: "Bullets",
    },
  ];
  columns = [
    {
      header: "Section",
      icon: "Document",
      field: "section",
    },
    {
      header: "Name",
      icon: "Pencil",
      field: "name",
    },
    {
      header: this.t("description"),
      icon: "Barcode",
      field: "description",
    },
  ];
  listingFooterControls = [
    {
      key: "cancel",
      label: this.t("cancel"),

      icon: PrimeIcons.PLUS_CIRCLE,
    },
    {
      key: "add",
      label: this.t("save"),
      icon: PrimeIcons.PLUS_CIRCLE,
    },
  ];
  permissions = [
    {
      id: 58,
      display_name: "Accounts",
      icon: "BoxWithStar",
    },
    {
      key: "employee",
      display_name: "Employees",
      icon: "BlueSilhouette",
    },
    {
      key: "charge",
      display_name: "Charges",
      icon: "CreditCardRed",
    },
    {
      key: "check",
      display_name: "Checks",
      icon: "Check",
    },
    {
      key: "credit_memo",
      display_name: "Credit Memos",
      icon: "Check",
    },
    {
      key: "customer",
      display_name: "Customers",
      icon: "GreenSilhouette",
    },
    {
      key: "deposit",
      display_name: "Deposits",
      icon: "Safe",
    },
    {
      key: "estimate",
      display_name: "Estimates",
      icon: "FAX",
    },
    {
      key: "expence_check",
      display_name: "Expence Check",
      icon: "Check",
    },
    {
      key: "file",
      display_name: "Files",
      icon: "Document",
    },
    {
      key: "fixed_asset",
      display_name: "Fixed Assets",
      icon: "Drawer",
    },
    {
      key: "folder",
      display_name: "Folders",
      icon: "Folder",
    },
    {
      key: "general_payment",
      display_name: "General Payment",
      icon: "Money",
    },
    {
      key: "invoice",
      display_name: "Invoices",
      icon: "Money",
    },
    {
      key: "invoicing",
      display_name: "invoicing Write Offs",
      icon: "Invoice",
    },
    {
      key: "job",
      display_name: "Jobs",
      icon: "Briefcase",
    },
    {
      key: "entries",
      display_name: "Journal Entries",
      icon: "Pencil",
    },
    {
      key: "milage",
      display_name: "Milage & Expences",
      icon: "Calculator",
    },
    {
      key: "oppertunitiy",
      display_name: "Oppertunities",
      icon: "BriefcaseWithQuestion",
    },
    {
      key: "other_contact",
      display_name: "Other Contacts",
      icon: "YellowSilhouette",
    },
    {
      key: "payable_bill",
      display_name: "Payable Bills",
      icon: "Billable",
    },
    {
      key: "payable_credit",
      display_name: "Payable Credits",
      icon: "Check",
    },
    {
      key: "payable_payment",
      display_name: "Payable Payments",
      icon: "Money",
    },
    {
      key: "prospect",
      display_name: "Prospects",
      icon: "GreenSilhouette",
    },
    {
      key: "reconcilation",
      display_name: "Reconcilations",
      icon: "Bank",
    },
    {
      key: "sales_receipt",
      display_name: "Sales Receipts",
      icon: "Invoice",
    },
    {
      key: "time_off",
      display_name: "Time Off",
      icon: "Clock",
    },
    {
      key: "time_worked",
      display_name: "Time Worked",
      icon: "Clock",
    },
    {
      key: "transfer",
      display_name: "Transfers",
      icon: "Repeat",
    },
    {
      key: "user",
      display_name: "Users",
      icon: "UserSilhouette",
    },
    {
      key: "vendor",
      display_name: "Vendors",
      icon: "OrangeSilhouette",
    },
    {
      key: "work_order",
      display_name: "Work Orders",
      icon: "database",
    },
  ];

  filterItems = [{ name: "Section", value: "0" }];

  constructor() {
    super("permissions");
    // super("customers");
  }
}
